﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalExchangerBnBContract = void 0;
const ContractFacade_1 = require("./abstact/ContractFacade");
const InternalExchangerBnBABI_1 = require("./abi/InternalExchangerBnBABI");
class InternalExchangerBnBContract extends ContractFacade_1.ContractFacade {
    constructor(address, web3) {
        super(address, web3, InternalExchangerBnBABI_1.InternalExchangerBnBABI.GetABI());
    }
    getBalance() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.web3.eth.getBalance(this.address);
            return this._toEther(res);
        });
    }
}
exports.InternalExchangerBnBContract = InternalExchangerBnBContract;
//# sourceMappingURL=InternalExchangerBnBContract.js.map